import type { BaseAnalyticsData } from './AppAnalytics';
import type { SnowflakeQueries } from './AppAnalyticsSnowflakeService';

export interface AaExecuteSyncBatchItem {
  id: string;
  queryString: string;
  maxResults?: number;
}

export interface AaExecuteSyncBatchRequest {
  appName: 'FuelTools';
  provider: 'SnowflakeLegacy';
  queries: AaExecuteSyncBatchItem[];
  maxConcurrency?: number;
}

export interface AaQueryResult {
  queryExecutionStatus: 'Queued' | 'Running' | 'Failed' | 'Succeeded' | 'Timeout' | 'SchemaNotProvisioned';
  message?: string;
  data: BaseAnalyticsData[];
  nextPageToken?: string;
}

export interface AaExecuteSyncBatchResponse {
  results: Record<string, AaQueryResult>;
}

export type DashboardBatchResults = Partial<Record<SnowflakeQueries, BaseAnalyticsData[]>>;

export const DASHBOARD_BATCH_QUERY_KEYS = [
  'pageViews',
  'videoViews',
  'uniqueVisitors',
  'contentByTop',
  'topChannels',
  'videoByDevice',
  'videoByCountry',
] as const satisfies readonly SnowflakeQueries[];
